import { setChatMinimized } from '../../../../../../actions/layout'
import { PREVIEW_SIZES } from '../../../../../../app-state/modals'
import { FloaterSize, RoomView } from '../../../../../../constants/enums'
import { isAndroid } from '../../../../../../utilities/browser'
import { COMPONENT_HEIGHTS } from '../../../../../theme'
export const HEIGHT_OFFSET =
    COMPONENT_HEIGHTS.chatHeader +
    COMPONENT_HEIGHTS.actionsBar +
    COMPONENT_HEIGHTS.compose

export const NO_COMPOSE_HEIGHT_OFFSET =
    COMPONENT_HEIGHTS.chatHeader + COMPONENT_HEIGHTS.actionsBar

export const MIN_CHAT_HEIGHT = 180

export const MOVEMENT_THRESHOLD = 0.04
export const MOBILE_CONVERSION_THRESHOLD = 0.45
export const TOUCH_CONVERSION_THRESHOLD = 0.55
export const SMALL_PREVIEW_SIZE = PREVIEW_SIZES[FloaterSize.Small]

export interface ViewProps {
    // room config
    id: number
    roomView: RoomView
    size: FloaterSize
    width: number
    height: number
    vertical: boolean
    fullWindow: boolean
    disableKeyboardOpenDetection: boolean

    // room state
    showVideo: boolean
    showZoomVideo?: boolean
    showLoungePreviews?: boolean
    viewingTips: boolean
    noProfileVideo: boolean
    noVideoDefault?: boolean
    surrogateName?: string
    isSurrogateBroadcasting?: boolean

    // room actions
    setZoomVideo?: (cb: any) => void
    setLoungePreviews?: (cb: any) => void
    toggleTips: () => void

    // composition
    // chatInputChild?: ReactElement
    // albumChild?: ReactElement
    // whiteboardChild?: ReactElement
}

export const DRAG_INDICATOR = {
    shown: false,
}

export const animateActionBar = (actionsBar: HTMLDivElement) => {
    if (!actionsBar) return
    const animation = actionsBar.animate(
        {
            translateY: [-40, 0],
            opacity: [0, 1],
        },
        180,
    )
    actionsBar.style.height = 'unset'
    actionsBar.style.minHeight = 'unset'
    actionsBar.style.maxHeight = 'unset'
    actionsBar.style.opacity = 'unset'
    actionsBar.style.pointerEvents = 'unset'
    animation.id = 'action-bar-show'
    return animation
}

export const minimizeChat = () => setChatMinimized(true)
export const restoreChat = () => setChatMinimized(false)

export const getRightStyles = ({
    vertical = false,
    fullWindow = false,
    isModel = false,
    division = 70,
}) => {
    if (vertical) return 'unset' as const
    if (fullWindow) return null
    if (isModel) return `${100 - division}%` as const
    return null
}

export const getLeftStyles = ({
    vertical = false,
    banned = false,
    isLounge = false,
    fullWindow = false,
    isModel = false,
    division = 70,
}) => {
    if (vertical) return 'unset' as const
    if (fullWindow || (banned && !isLounge)) return '100%' as const
    if (isModel) return `${division}%` as const
    return 'auto' as const
}

export const getVerticalChatHeight = ({
    isMobile,
    isOffline,
    isBroadcasting,
    isPM,
    height,
    videoHeight,
    showVideo,
}) => {
    const usableHeight = showVideo ? height - videoHeight : height
    if (isPM) {
        if (isOffline || !isBroadcasting) {
            if (isMobile) {
                return Math.floor(
                    usableHeight - COMPONENT_HEIGHTS.chatHeaderOffline,
                )
            } else {
                return Math.floor(
                    usableHeight - COMPONENT_HEIGHTS.chatHeaderOfflineDesktop,
                )
            }
        } else {
            return Math.floor(
                usableHeight -
                    (COMPONENT_HEIGHTS.chatHeader +
                        COMPONENT_HEIGHTS.actionsBar),
            )
        }
    }

    return Math.floor(
        usableHeight -
            (COMPONENT_HEIGHTS.chatHeader + COMPONENT_HEIGHTS.actionsBar),
    )
}

export const calcZoomedVideoHeight = (height, width) =>
    Math.min(
        Math.max(height - HEIGHT_OFFSET - MIN_CHAT_HEIGHT, (width * 9) / 16),
        600,
    )

export const resolveVerticalVideoHeight = (options) => {
    const { isFullscreen, pinToTop, height, width, size } = options

    // if (zoomVideo) {
    //     // const zoomVideoHeightMultiplier = 0.57
    //     // return height * zoomVideoHeightMultiplier
    //     return calcZoomedVideoHeight(height, width)
    // }

    if (pinToTop && isAndroid) {
        const componentsHeight =
            COMPONENT_HEIGHTS.navBottom + COMPONENT_HEIGHTS.compose

        const availableHeight = window.visualViewport.height - componentsHeight

        if (availableHeight < (width * 9) / 16) {
            return availableHeight
        }
    }

    if (isFullscreen) {
        return (width * 9) / 16
    }

    if (size > FloaterSize.Small) {
        return height - COMPONENT_HEIGHTS.chatHeader
    }

    return height
}

export const moveZoomedVideoIcons = (
    rightPosition: number,
    leftPosition: number,
) => {
    const zoomedVideojsMenu = document.querySelector(
        '.zoom-video.videoplayerjs > .video-js > .vjs-control-bar > .vjs-menu-button',
    ) as HTMLDivElement
    const zoomedVideojsVolume = document.querySelector(
        '.zoom-video.videoplayerjs > .video-js > .vjs-control-bar > .vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal',
    ) as HTMLDivElement

    if (zoomedVideojsMenu) {
        zoomedVideojsMenu.style.right = `${rightPosition}px`
    }
    if (zoomedVideojsVolume) {
        zoomedVideojsVolume.style.left = `${leftPosition}px`
    }
}

export const resetZoomedVideoIcons = () => {
    const zoomedVideojsMenu = document.querySelector(
        '.zoom-video.videoplayerjs > .video-js > .vjs-control-bar > .vjs-menu-button',
    ) as HTMLDivElement
    const zoomedVideojsVolume = document.querySelector(
        '.zoom-video.videoplayerjs > .video-js > .vjs-control-bar > .vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal',
    ) as HTMLDivElement
    if (zoomedVideojsMenu) {
        zoomedVideojsMenu.style.right = 'unset'
    }
    if (zoomedVideojsVolume) {
        zoomedVideojsVolume.style.left = 'unset'
    }
}
